import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store';
import {
  toggleCart,
  setFinalPrice,
  setSubtotalPrice,
  setCartProducts,
  addItem,
  setProductsQuantity,
  toggleWarranty,
  removeItem,
  setWarrantyData,
  setTotalSavings,
  setSavingsQuantityPrice,
  loadLazy,
  isHeroVisible,
  adjustItemQuantity,
  setLoader,
  CartItem,
  ProductCartItem,
  addMainProduct,
} from './slice';
import { calculateMainTotals } from '@utils/cartHelpers';
import { WarrantyProduct } from './types';
import { ProductItem } from '../productsState/productsTypes';
export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useCartActions = () => {
  const dispatch = useAppDispatch();

  const heroVisibleAction = () => dispatch(isHeroVisible());

  const toggleLoaderAction = () => dispatch(setLoader());

  const toggleCartAction = () => dispatch(toggleCart());
  const loadLazyComponentsAction = () => dispatch(loadLazy());

  const setFinalPriceAction = (payload: { total: number; savings: number }) => {
    dispatch(setFinalPrice(payload));
  };

  const adjustItemQuantityAction = (payload: { quantity: number; id: string }) => {
    dispatch(adjustItemQuantity(payload));
  };

  const setProductsQuantityAction = () => {
    dispatch(setProductsQuantity());
  };

  const toggleProtectionAction = (state: boolean) => {
    dispatch(toggleWarranty(state));
  };

  const setWarrantyDataAction = (data: WarrantyProduct) => {
    dispatch(setWarrantyData(data));
  };

  const setTotalSavingsAction = () => {
    dispatch(setTotalSavings());
  };

  const setCartProductsAction = (cartItems: ProductCartItem[]) => {
    dispatch(setCartProducts(cartItems));
  };

  const addItemAction = (item: ProductCartItem) => {
    dispatch(addItem(item));
  };

  const addMainProductAction = (item: ProductCartItem, isEmptyCart: boolean) => {
    dispatch(addMainProduct({ item, isEmptyCart }));
  };

  const removeItemAction = (id: string) => {
    dispatch(removeItem(id));
  };

  const setSavingsQuantityPriceAction = () => {
    dispatch(setSavingsQuantityPrice());
  };

  const calculateTotalsAction = () =>
    dispatch((dispatch, getState) => {
      const state = getState();
      const { cartProducts, warrantyProduct } = state.cart;
      const { freeShippingPrice } = state.cart;

      const { mainTotal, mainSavings } = calculateMainTotals(cartProducts);

      function isProduct(item: CartItem): item is ProductItem {
        return (item as ProductItem).shipping_price !== undefined;
      }
      const productsWithShipping = cartProducts.filter(isProduct);
      const shippingCost = productsWithShipping.reduce((acc, product) => acc + Number(product.shipping_price), 0);
      const warrantyState = warrantyProduct.warrantyState;
      const wanrratyPrice = warrantyState ? warrantyProduct.price : 0;
      let subTotal;
      let finalSavings;
      if (mainTotal < freeShippingPrice) {
        subTotal = mainTotal + shippingCost + Number(wanrratyPrice);
        finalSavings = mainSavings;
      } else {
        subTotal = mainTotal + Number(wanrratyPrice);
        finalSavings = mainSavings;
      }
      dispatch(setSubtotalPrice({ subTotal }));
      dispatch(
        setFinalPrice({
          total: parseFloat(subTotal.toFixed(2)),
          savings: parseFloat(finalSavings.toFixed(2)),
        })
      );
    });

  return {
    heroVisibleAction,
    toggleLoaderAction,
    toggleCartAction,
    loadLazyComponentsAction,
    setFinalPriceAction,
    setProductsQuantityAction,
    toggleProtectionAction,
    setWarrantyDataAction,
    setTotalSavingsAction,
    setCartProductsAction,
    addItemAction,
    removeItemAction,
    adjustItemQuantityAction,
    setSavingsQuantityPriceAction,
    calculateTotalsAction,
    addMainProductAction,
  };
};
